module.exports = __webpack_public_path__ + "img/askAboutActive.474cb523.png";